import { jsxs as l, jsx as r } from "react/jsx-runtime";
const o = ({
  width: i,
  height: t,
  className: C
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: C,
    fill: "none",
    height: t,
    viewBox: "0 0 19 20",
    width: i,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "g",
        {
          clipPath: "url(#clip0_2636_933)",
          id: "Layer_1",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                d: "M2.49225 0.0125239L16.0049 0C17.2943 0.125239 18.4542 1.04783 18.5741 2.38609V17.6115C18.453 18.9641 17.268 19.8938 15.9625 20H2.61152C1.30188 19.8932 0.123449 18.9671 0 17.6115L0.0023855 2.34375C0.14969 1.05916 1.23986 0.154461 2.49225 0.0125239ZM2.57991 1.43965C2.03304 1.54222 1.49094 1.87858 1.4307 2.47793L1.42832 17.4785C1.47066 18.1375 2.09029 18.5156 2.70038 18.5723H15.8725C16.4909 18.4948 17.0837 18.156 17.1452 17.4791V2.51968C17.1028 1.86069 16.4826 1.48259 15.8725 1.42593L2.57932 1.43905L2.57991 1.43965Z",
                fill: "currentColor",
                id: "Vector"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                d: "M10.0013 2.85596V3.79346C10.8034 4.03439 11.4934 4.79059 11.4296 5.66846H10.0681C9.91424 5.20925 9.47591 4.99336 9.00954 5.14544C8.51574 5.30646 8.36009 5.78714 8.88371 6.04954C9.26062 6.23799 9.74189 6.23322 10.1468 6.39365C11.927 7.09797 11.831 9.50076 10.0013 10.0435V10.981H8.573V10.0435C7.7822 9.79358 7.0755 9.04453 7.14468 8.16846H8.5062C8.59685 8.26865 8.57896 8.40581 8.67796 8.51018C9.00298 8.85488 10.0144 8.77437 10.0067 8.18993C9.99952 7.63888 8.90697 7.60369 8.50561 7.45519C6.64373 6.76698 6.70336 4.36896 8.57359 3.79346V2.85596H10.0019H10.0013Z",
                fill: "currentColor",
                id: "Vector_2"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                d: "M15.0016 12.1416H3.57324V13.5699H15.0016V12.1416Z",
                fill: "currentColor",
                id: "Vector_3"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                d: "M15.0016 14.999H3.57324V16.4273H15.0016V14.999Z",
                fill: "currentColor",
                id: "Vector_4"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "clip0_2636_933", children: /* @__PURE__ */ r(
        "rect",
        {
          fill: "white",
          height: "20",
          width: "18.5741"
        }
      ) }) })
    ]
  }
);
export {
  o as Content
};
